import Reflux from 'reflux';
import { SchoolClassAPI } from './refluxApi';

// use by TopicGrid only
export const StudentLessonProgressActions = Reflux.createActions({
  load: {
    asyncResult: true,
  },
});

StudentLessonProgressActions.load.listenAndPromise(
  SchoolClassAPI.fetchStudentLessonProgress
);
